module.exports = __webpack_public_path__ + "img/fun4.a13418ad.png";